import Warehouse from "./warehouse"

export default {
    Warehouse
}



// WEBPACK FOOTER //
// ./src/pages/ERP/Warehouse/forms/index.js